module.exports = __webpack_public_path__ + "img/ZB_colour_palette.3a87c2be.webp";